import {Runner} from "angular-ecmascript/module-helpers";

export default class CacheConfig extends Runner {
    static $inject = ['$http', 'CacheFactory'];


    run() {
        // HTTP Cache
        this.CacheFactory('http', {
            maxAge: 15 * 60 * 1000,             // Items added to this cache expire after 15 minutes.
            cacheFlushInterval: 60 * 60 * 1000, // This cache will clear itself every hour.
            deleteOnExpire: 'aggressive',       // Items will be deleted from this cache right when they expire.
            storageMode: 'localStorage'         // This cache will sync itself with `localStorage`
        });

        this.CacheFactory.clearAll();
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/cache.config.js